import React, { FC, useCallback, useMemo } from "react";
import { Pressable } from "react-native";
import { SvgProps } from "react-native-svg";
import invariant from "tiny-invariant";
import {
  CheckoutFeedbackQuestionIcon,
  CheckoutFeedbackQuestionType,
} from "../../../../../../../projection/checkoutFeedback/checkoutFeedback.constants";
import { useCheckoutQuestionFeedbackForId } from "../../behaviors/useCheckoutQuestionFeedback";
import { CheckoutQuestionItem } from "../CheckoutQuestionItem";
import { style as iconCheckoutQuestionItemStyle } from "./IconCheckoutQuestionItem.style";
import { Happy } from "./icons/Happy";
import { Normal } from "./icons/Normal";
import { Sad } from "./icons/Sad";

const ICON: Record<CheckoutFeedbackQuestionIcon, FC<SvgProps>> = {
  ["checkout_feedback.icon.bad"]: Sad,
  ["checkout_feedback.icon.regular"]: Normal,
  ["checkout_feedback.icon.good"]: Happy,
};

const IconCheckoutQuestionItem: CheckoutQuestionItem<CheckoutFeedbackQuestionType.ICON> = ({
  checkoutQuestion,
  checkoutQuestionParentId,
  testID,
}) => {
  const Icon = ICON[checkoutQuestion.metadata.icon];

  const style = useMemo(() => iconCheckoutQuestionItemStyle(), []);

  const { feedback, onChange } = useCheckoutQuestionFeedbackForId({ id: checkoutQuestionParentId });
  const isSelected = feedback === checkoutQuestion.id;

  const handleOnPress = useCallback(
    () => onChange({ checkoutQuestionId: checkoutQuestionParentId, checkoutQuestionFeedback: checkoutQuestion.id }),
    [onChange, checkoutQuestion.id, checkoutQuestionParentId],
  );

  invariant(Icon, "CheckoutQuestion icon does not exist");

  return (
    <Pressable accessibilityLabel={testID} testID={testID} onPress={handleOnPress}>
      <Icon
        color={style.colorIcon}
        fill={isSelected ? style.colorBgPrimaryMediumLight : "none"}
        strokeWidth={isSelected ? 2 : 1}
        style={style.icon}
      />
    </Pressable>
  );
};

export { IconCheckoutQuestionItem };
